import { ThankYouPageWrapper } from "./styles"

export const ThankYouPage = () => {
    return (
        <ThankYouPageWrapper>
            <h1>Thank you for using our service!</h1>
            <h3>Our designers will get back to you soon.</h3>
        </ThankYouPageWrapper>
    )
}